
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBlowerStaticHorizontal as ObiBlowerStaticHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-blower-static-horizontal.js';
 
 
 

 
 export const ObiBlowerStaticHorizontal = createComponent({
   react: React,
   tagName: 'obi-blower-static-horizontal',
   elementClass: ObiBlowerStaticHorizontalElement,
   events: {
     
   }
  });
 
 